import { gql } from '@apollo/client';

export default gql`
  mutation voidValidationTickets($validations: [VoidTicketValidationInput!]) {
    voidValidationTickets(validations: $validations)
  }
`;
